export default __webpack_public_path__ + "static/media/cushion-box2.5f165b2e.svg";